export default {
    'searchList': {
        'searchTxt': [
            {
                'name': '发车单号',
                'value': 'etdoNo',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '客户订单号',
                'value': 'ettaSoNo',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '运输单号',
                'value': 'ettaNo',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '发车单状态',
                'value': 'etdoStatus',
                'type': 'select',
                'optionNum': 'SYS_TRANSPORT_DO_STATUS',
                'filterable': true,
                'unfold': true,
                'multiple': true,
                'span': 4
            },
            {
                'name': '创建时间',
                'value': 'createTime',
                'startTime': 'createTimeFrom',
                'endTime': 'createTimeTo',
                'startPlaceholder': '创建开始日期',
                'endPlaceholder': '创建结束日期',
                'timeNum': 30,
                'type': 'time',
                'unfold': true,
                'span': 6
            }
        ],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table': {
        'clickModify': true,
        'selectBtn': true,
        'height': 400,
        'leftWidth': 220,
        'leftOperation': true,
        'columns': [
            {
                'label': '发车单号',
                'align': 'center',
                'value': 'orderNo',
                'prop': 'etdoNo',
                'sort': true,
                'width': 200
            },
            {
                'label': '线路',
                'align': 'center',
                'value': 'customerOrderNo',
                'prop': 'etdoLineName',
                'sort': true,
                'width': 200
            },
            {
                'label': '发车单状态',
                'prop': 'etdoStatusType',
                'sort': true,
                'width': 120
            },
            {
                'label': '是否打印提货单',
                'prop': 'isPrint',
                'sort': true,
                'width': 150
            },
            {
                'label': '承运商',
                'prop': 'etdoCarrierName',
                'sort': true,
                'width': 150
            },
            {
                'label': '车牌号',
                'prop': 'etdoVehicleCard',
                'sort': true,
                'width': 150
            },
            {
                'label': '特权修改人',
                'prop': 'etdoPrivilegeModifiName',
                'sort': true,
                'width': 150
            },
            {
                'label': '体积',
                'align': 'center',
                'prop': 'etdoVolume',
                'sort': true,
                'width': 200
            },
            {
                'label': '重量',
                'align': 'center',
                'prop': 'etdoTotalGrossWeight',
                'sort': true,
                'width': 170
            },
            {
                'label': '数量',
                'align': 'center',
                'prop': 'etdoTotalQty',
                'value': 'whCode',
                'sort': true,
                'width': 150
            },
            {
                'label': '实发发货数量',
                'align': 'center',
                'prop': 'etdoTotalEa',
                'sort': true,
                'width': 100
            },
            {
                'label': '装货仓库',
                'align': 'center',
                'prop': 'ettaOutWhName',
                'sort': true,
                'width': 150
            },
            {
                'label': '是否有分拨',
                'align': 'center',
                'prop': 'allotNumType',
                'sort': true,
                'width': 150
            },
            {
                'label': '运输单数量',
                'align': 'center',
                'prop': 'etdoTaskCount',
                'sort': true,
                'width': 130
            },
            {
                'label': '调度平台',
                'align': 'center',
                'prop': 'etdoScheduleSiteName',
                'sort': true,
                'width': 130
            },
            {
                'label': '分公司',
                'align': 'center',
                'prop': 'companyName',
                'sort': true,
                'width': 200
            },
            {
                'label': '服务平台',
                'align': 'center',
                'prop': 'siteName',
                'sort': true,
                'width': 200
            },
            {
                'label': '发车时间',
                'align': 'center',
                'prop': 'etdoDepartDate',
                'sort': true,
                'width': 200
            },
            {
                'label': '要求到车时间',
                'align': 'center',
                'prop': 'etdoBesArriveDate',
                'sort': true,
                'width': 200
            },
            {
                'label': '采购渠道',
                'align': 'center',
                'prop': 'etdoProcurementChannelType',
                'sort': true,
                'width': 200
            },
            // {
            //     'label': '直通宝标识',
            //     'align': 'center',
            //     'prop': 'etdoLtlFlagType',
            //     'sort': true,
            //     'width': 150
            // },
            {
                'label': '天猫入园预约时间',
                'align': 'center',
                'prop': 'etdoAdmissionDate',
                'sort': true,
                'width': 150
            },
            {
                'label': '备注',
                'align': 'center',
                'prop': 'etdoRemark',
                'sort': true,
                'width': 150
            },
            {
                'label': '是否在始发地围栏',
                'align': 'center',
                'prop': 'beginLandRail',
                'type': 'select',
                'options': [
                    { label: '否', value: '0' },
                    { label: '是', value: '1' }
                ],
                'sort': true,
                'width': 200
            },
            {
                'label': '是否在目的地围栏',
                'align': 'center',
                'prop': 'endLandRail',
                'type': 'select',
                'options': [
                    { label: '否', value: '0' },
                    { label: '是', value: '1' }
                ],
                'sort': true,
                'width': 150
            },
            {
                'label': '异常发车原因',
                'align': 'center',
                'prop': 'wholeExceptionTypeName',
                'sort': true,
                'width': 150
            },
            {
                'label': '异常发车原因说明',
                'align': 'center',
                'prop': 'wholeExceptionMsg',
                'sort': true,
                'width': 150
            },
            {
                'label': '发运类型',
                'align': 'center',
                'prop': 'shippingTypeName',
                'sort': true,
                'width': 150
            },
            {
                'label': '触碰目的地围栏时间',
                'prop': 'endLandRailTime',
                'sort': true,
                'width': 160
            },
            {
                'label': '到车人工操作原因',
                'align': 'center',
                'prop': 'etdoPickUpReason',
                'sort': true,
                'width': 160
            },
            {
                'label': '发车人工操作原因',
                'align': 'center',
                'prop': 'etdoDepartReason',
                'sort': true,
                'width': 160
            },
            {
                'label': '抵达人工操作原因',
                'prop': 'etdoArriveReason',
                'sort': true,
                'width': 160
            }
        ],
        'action': [
            {
                'type': 'text',
                'label': '编辑',
                'size': 'mini',
                'event': 'edit',
                'ifHas': '05030003'
            },
            {
                'type': 'text',
                'label': '到车',
                'size': 'mini',
                'event': 'toTheCar',
                'ifHas': '05030004'
            },
            {
                'type': 'text',
                'label': '整车异常发车原因',
                'size': 'mini',
                'event': 'abnormalReason',
                'ifHas': ''
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 50] // eslint-disable-line
    },
    'searchTotalTitle': [
        {
            'name': '集拼号',
            'value': 'ettaAssighNo',
            'type': 'input',
            'span': 4
        },
        {
            'name': '合同编号',
            'value': 'ettaContractNo',
            'type': 'input',
            'span': 4
        },
        {
            'name': '要求到车时间',
            'value': 'carTime',
            'startTime': 'etdoBesArriveDateFrom',
            'endTime': 'etdoBesArriveDateTo',
            'startPlaceholder': '要求到车开始日期',
            'endPlaceholder': '要求到车结束日期',
            'type': 'time',
            'span': 7
        },
        {
            'name': '线路',
            'value': 'eblnLineName',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'eblnLineCode', 'value': '代码' },
                { 'prop': 'eblnLineName', 'value': '名称' }
            ],
            'tableConfig': [
                { 'prop': 'eblnLineCode', 'value': '代码' },
                { 'prop': 'eblnLineName', 'value': '名称' },
                { 'prop': 'eblnRatedMileage', 'value': '额定里程' }
            ],
            'advanceUrl': '/ebLine/search',
            'cbParams': ['eblnLineCode#etdoLineCode', 'eblnLineName', 'eblnRatedMileage'],
            'span': 4
        },
        {
            'name': '车牌号',
            'value': 'etdoVehicleCard',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'licensePlateNumber', 'value': '车牌' },
                { 'prop': 'cargoVolumeStr', 'value': '载货体积' },
                { 'prop': 'cdegNameCn', 'value': '车型' }
            ],
            'tableConfig': [
                { 'prop': 'licensePlateNumber', 'value': '车牌' },
                { 'prop': 'cargoVolume', 'value': '载货体积' },
                { 'prop': 'cdegNameCn', 'value': '车型' }
            ],
            'advanceUrl': 'suCar/searchByConditions',
            'cbParams': [
                'licensePlateNumber#etdoVehicleCard', 'cdegNameCn#etdoEquipmentName', 'etveType#etdoEquipmentType'
            ],
            'type': 'advance',
            'advanceCascade': 'carrierCode#suppliersCode'
        },
        {
            'name': '已打印提货单',
            'value': 'isPrint',
            'type': 'select',
            'optionNum': 'SYS_YES_NO_APP',
            'filterable': true,
            'options': [],
            'span': 4
        },
        {
            'name': '物流订单号',
            'value': 'ettaOrderNo',
            'type': 'input',
            'span': 4
        },
        // {
        //     'name': '直通宝标识',
        //     'value': 'etdoLtlFlag',
        //     'type': 'select',
        //     'optionNum': 'SYS_TMS_ZTB_FLAG',
        //     'filterable': true,
        //     'options': [],
        //     'span': 4
        // },
        {
            'name': '装货仓库',
            'value': 'ettaOutWhCode',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'cdwhName', 'value': '仓库名称' },
                { 'prop': 'whCode', 'value': '仓库编码' }
            ],
            'tableConfig': [
                { 'prop': 'whCode', 'value': '仓库编码' },
                { 'prop': 'cdwhName', 'value': '仓库名称' }
            ],
            'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
            'cbParams': [
                'whCode#ettaOutWhCode', 'cdwhName#ettaOutWhCode'
            ],
            'type': 'advance',
            'advanceCode': 'cdwhName'
        },
        {
            'name': '发运类型',
            'value': 'shippingType',
            'type': 'select',
            'optionNum': 'LSP_SHIPPING_TYPE',
            'filterable': true,
            'options': [],
            'span': 4
        }
    ],
    'dateDialog': {
        'type': 'date',
        'title': '预约',
        'width': '1000px',
        'hideFooter': true,
        'hideTable': true,
        'dayHeight': '20px',
        'calendarWidth': '30%',
        'formBoxWidth': '70%',
        'btnList': [{
            'type': 'negative',
            'text': '重置'
        }, {
            'type': 'sure',
            'text': '保存'
        }],
        'dialogForm': {
            'inline': false,
            'labelWidth': 7,
            'inputWidth': 15,
            'inputList': [{
                'label': '预约时间',
                'value': 'appointTime',
                'prop': 'appointTime',
                'placeholder': '预约时间',
                'disabled': true,
                'span': 12,
                'type': 'text'
            }, {
                'label': '改约一级原因',
                'prop': 'appointReason',
                'value': 'appointReason',
                'placeholder': '请选择',
                'span': 12,
                'type': 'select'
            }, {
                'label': '预约类型',
                'prop': 'appointType',
                'value': 'appointType',
                'placeholder': '请选择',
                'span': 12,
                'type': 'dictionary',
                'optionNum': 'APPOINTMENT_TYPE'
            }, {
                'label': '改约二级原因',
                'prop': 'secendAppointReason',
                'value': 'secendAppointReason',
                'placeholder': '请选择',
                'span': 12,
                'type': 'select'
            }, {
                'label': '预约异常类型',
                'prop': 'exceptionType',
                'value': 'exceptionType',
                'placeholder': '请选择',
                'span': 12,
                'type': 'dictionary',
                'optionNum': 'CAINIAO_WMS_ERROR'
            }, {
                'label': '备       注',
                'prop': 'remarks',
                'value': 'remarks',
                'placeholder': '备注',
                'span': 12,
                'type': 'text'
            }]
        }
    },
    'logColumns': [
        {
            'prop': 'orderNo',
            'label': '订单号',
            'type': 'normal'
        },
        {
            'prop': 'taskNo',
            'label': '任务号',
            'type': 'normal'
        },
        {
            'prop': 'operateName',
            'label': '操作类型',
            'type': 'normal'
        },
        {
            'prop': 'operateContent',
            'label': '操作内容',
            'type': 'normal'
        },
        {
            'prop': 'createUserCode',
            'label': '创建人',
            'type': 'normal'
        },
        {
            'prop': 'createTime',
            'label': '创建时间',
            'type': 'normal'
        }
    ],
    'viewBillBasicData': {
        'carNumber': {
            'name': '必填',
            'advanceLabel': '车牌号',
            'value': 'etdoVehicleCard',
            'advanceConfig': [
                { 'prop': 'licensePlateNo', 'value': '车牌' },
                { 'prop': 'maxVolume', 'value': '载货体积' },
                { 'prop': 'carTypeNameCn', 'value': '车型' },
                { 'prop': 'carType', 'value': '车型编码' }
            ],
            'tableConfig': [
                { 'prop': 'licensePlateNo', 'value': '车牌' },
                { 'prop': 'maxVolume', 'value': '载货体积' },
                { 'prop': 'carTypeNameCn', 'value': '车型' },
                { 'prop': 'carType', 'value': '车型编码' }
            ],
            'cbParams': [
                'licensePlateNo#etdoVehicleCard', 'carTypeNameCn#etdoEquipmentName', 'carType#etdoEquipmentType'
            ],
            'method': 'post',
            'prefix': '/api-srm-web/',
            'advanceUrl': 'basis/supplierCarInfos/getEnableCarListBySupplierCode',
            'advanceCascade': 'supplierCode,routeNoList'
        },
        'driverLists': {
            'name': '请输入司机',
            'advanceLabel': '司机',
            'value': 'etdoMainDriver',
            'advanceConfig': [
                { 'prop': 'driverName', 'value': '司机' },
                { 'prop': 'driverPhone', 'value': '电话' },
                { 'prop': 'driverCode', 'value': 'DN编码' },
                { 'prop': 'driverIdCard', 'value': '身份证号' }
            ],
            'tableConfig': [
                { 'prop': 'driverName', 'value': '司机' },
                { 'prop': 'driverPhone', 'value': '电话' },
                { 'prop': 'driverCode', 'value': 'DN编码' },
                { 'prop': 'driverIdCard', 'value': '身份证号' }
            ],
            'cbParams': [
                'driverName#etdoMainDriver', 'driverCode#etdoMainDriverNo', 'driverPhone#etdoMainDriverContactWay'
            ],
            'method': 'post',
            'prefix': '/api-srm-web/',
            'advanceUrl': 'basis/supplierDriverInfo/getEnableDriverListBySupplierCode',
            'advanceCascade': 'supplierCode,routeNoList'
        }
    }
};
